import React, { useEffect, useState } from "react";
import styled from "styled-components";
import "../../../assets/css/liveBox.css";

const StyledIframeWrapper = styled.div`
  position: relative;
  &:before {
    content: "";
    display: block;
    padding-bottom: calc(100% / (16 / 9));
  }
`;

const StyledIframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const LivestreamBox = (props) => {
  const youtubeApiKey = props.youtubeApiKey;
  const youtubeChannelId = props.youtubeChannelId;
  // console.log("Apiは" + youtubeApiKey, "IDは" + youtubeChannelId);
  // const {
  //   youtubeChannelId,
  //   youtubeApiKey,
  // } = props

  const [isLive, setIsLive] = useState(false);
  const [youtubeVideoId, setYoutubeVideoId] = useState(null);

  const fetchYoutubeData = () => {
    fetch(
      `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${youtubeChannelId}&eventType=live&type=video&key=${youtubeApiKey}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
      .then(async (res) => {
        const response = await res.json();
        console.log(response);

        if (response.items && response.items.length >= 1) {
          const streamInfo = response.items[0];
          setIsLive(true);
          setYoutubeVideoId(streamInfo.id.videoId);
          // console.log("setIsLiveでtrueになってる発火");
        }
      })
      .catch((err) => {
        console.log("通信に失敗しました");
        // console.log("☆Error fetching data from YouTube API: ", err);
      });
  };

  function processYoutubeStream() {
    if (youtubeChannelId && youtubeApiKey) {
      console.log("fetchYoutubeData成功");
      fetchYoutubeData();
    } else {
      console.log("fetchYoutubeData失敗");
      // console.error("[react-livestream] YouTube support requires a youtubeApiKey and youtubeChannelId prop");
    }
  }

  function embedIframe() {
    return (
      <StyledIframe
        src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1&mute=1`}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></StyledIframe>
    );
  }

  useEffect(() => {
    processYoutubeStream();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isLive === false) {
      processYoutubeStream();
    }
    // eslint-disable-next-line
  }, [youtubeChannelId]);

  return isLive ? (
    // <div className="live-box">
    <StyledIframeWrapper>{embedIframe()}</StyledIframeWrapper>
  ) : (
    // </div>
    <div className="live-box-ready yu-gothic">配信までお待ちください</div>
  );
};

export default LivestreamBox;
